// extracted by mini-css-extract-plugin
export default {"hero_img":"Carousel_hero_img__rgCbR","hero__img":"Carousel_hero__img__gDQub"};